var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isSale)?_c('sale-monthly-performance-self-list'):_c('sale-monthly-performance-admin-list')}
var staticRenderFns = []

export { render, staticRenderFns }